import React from 'react'

import InviteTypeButton from '@/components/modals/InviteToRqModal/InviteTypeButton'
import { InviteToRqModalStep } from '@/components/modals/InviteToRqModal/types'
import { ROUTES } from '@/lib/routes'

interface Props {
  onSelect: (newStepName?: InviteToRqModalStep) => void
}

const InviteTypeChoice: React.FC<Props> = ({ onSelect }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
    <InviteTypeButton
      iconName="barChart"
      text="Invite your referral partners to RQ"
      onClick={() => onSelect('referralPartners')}
    />

    <InviteTypeButton
      iconName="groupOfPeople"
      text="Invite a colleague to join your account on RQ"
      href={ROUTES.manageUsers({ searchParams: { showInviteModal: 'true' } })}
      onClick={onSelect}
    />
  </div>
)

export default InviteTypeChoice
